export const ARCHITECT_PERSONA = 'Architect';
export const BUSINESS_PERSONA = 'Business';
export const ADMIN_PERSONA = 'Admin';
export const PERSONA_LABEL = 'Persona';
export const LINE_OF_BUSINESS_LABEL = 'Line of Business';
export const SET_PERSONA_LABEL = 'Set Persona';
export const EDIT_PERSONA_ARIA_LABEL = 'Edit persona';
export const PERSONA_OPTIONS_ARIA_LABEL = 'Persona options';
export const LINE_OF_BUSINESS_OPTIONS_ARIA_LABEL = 'Line of business options';
export const PERSONA_SECTION_ID = 'persona';
export const LINE_OF_BUSINESS_SECTION_ID = 'line-of-business';
export const PERSONA_PROFILE_ROUTE = `/profile#${PERSONA_SECTION_ID}`;
export const WELCOME_PAGE_ROUTE = '/welcome';
export const PROFILE_SELECTION_HINT = '(select one)';
export const PERSONA_OPTIONS = [
  ARCHITECT_PERSONA,
  ADMIN_PERSONA,
] as const;

export interface PersonaOptionItem {
  value: string;
  label: string;
  disabled: boolean;
}

export const PERSONA_OPTION_ITEMS: readonly PersonaOptionItem[] = [
  { value: ARCHITECT_PERSONA, label: ARCHITECT_PERSONA, disabled: false },
  { value: BUSINESS_PERSONA, label: `${BUSINESS_PERSONA} (coming soon)`, disabled: true },
  { value: ADMIN_PERSONA, label: ADMIN_PERSONA, disabled: false },
];

export const LINE_OF_BUSINESS_OPTIONS = [
  'DTO - Assets Architect',
  'DTO - Customer and Renewables Architect',
  'DTO - Data Architect',
  'DTO - Digital Innovation Architect',
  'DTO - Enterprise and Global Functions Architect',
  'DTO - Subsurface and Wells Architect',
  'DTO - Trading and Supply Architect',
] as const;

export const isLineOfBusinessRequired = (
  persona: string | null | undefined,
): boolean => persona === ARCHITECT_PERSONA;